import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'

// Pages Imports
import SectionAdventureFeed from './components/SectionAdventureFeed.vue'
import SectionAdventureRecentFeed from './components/SectionAdventureRecentFeed.vue'
import SectionAdventureEdit from './components/SectionAdventureEdit.vue'
import SectionChapters from './components/SectionChapters.vue'
import SectionObjects from './components/SectionObjects.vue'
import SectionTimeline from './components/SectionTimeline.vue'
import SectionStages from './components/SectionStages.vue'
import SectionStageCompose from './components/SectionStageCompose.vue'
import SectionContact from './components/SectionContact.vue'
import SectionSplashScreen from './components/SectionSplashScreen.vue'
import SectionUserProfile from './components/SectionUserProfile.vue'
import SectionMyAdventures from './components/SectionMyAdventures.vue'
import SectionPlay from './components/SectionPlay.vue'
import SectionNotFound from './components/SectionNotFound.vue'

Vue.use(Router)

const routes= [
    { path: '/', name:'home', component: SectionAdventureFeed },
    { path: '/recent', name:'recent', component: SectionAdventureRecentFeed },
    { path: '/editor/play/:adventure', name:'editorPlayer', component: SectionPlay },
    { path: '/play/:adventure', name:'player', component: SectionPlay },
    { path: '/editor/:adventure/chapters/:chapter/timeline/:group', name:'editorTimelineGroup', component: SectionTimeline },
    { path: '/editor/:adventure/chapters/:chapter/timeline', name:'editorTimeline', component: SectionTimeline },
    { path: '/editor/:adventure/chapters/:chapter/objects/:object', name:'editorObjId', component: SectionObjects },
    { path: '/editor/:adventure/chapters/:chapter/objects', name:'editorObj', component: SectionObjects },
    { path: '/editor/:adventure/chapters/:chapter/stages/:stage/compose', name:'editorStgCompose', component: SectionStageCompose },
    { path: '/editor/:adventure/chapters/:chapter/stages/:stage', name:'editorStgId', component: SectionStages },
    { path: '/editor/:adventure/chapters/:chapter/stages', name:'editorStg', component: SectionStages },
    { path: '/editor/:adventure/chapters/:chapter', name:'editorChpId', component: SectionChapters },
    { path: '/editor/:adventure/chapters', name:'editorChp', component: SectionChapters },
    { path: '/editor/:adventure', name:'editorAdv', component: SectionAdventureEdit },
    { path: '/editor', name:'editor', component: SectionMyAdventures },
    { path: '/documentation', name:'documentation', component: SectionContact },
    { path: '/contact', name:'contact', component: SectionContact },
    { path: '/login', name:'login', component: SectionSplashScreen },
    { path: '/profile', name:'profile', component: SectionUserProfile },
    { path: '*', name:'notfound', component: SectionNotFound }
  ]

 const router = new Router({
   routes 
})

// Vue.filter('reverse', function(array) {
//   console.log(value);
//   // slice to make a copy of array, then reverse the copy
//   return array.slice().reverse();
// });

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./C:/Git/adventify-vuefire/src/main.js